import { useEffect, useState } from 'react';

import { getPrice, Resolution } from '~/api/chart/chart-service';
import { Entity } from '~/api/entities/entity-schema';

const initialData = [
  { time: '2018-12-23', value: 31.11 },
  { time: '2018-12-24', value: 27.02 },
  { time: '2018-12-25', value: 28.02 },
  { time: '2018-12-26', value: 25.17 },
  { time: '2018-12-27', value: 19.89 },
  { time: '2018-12-28', value: 25.46 },
  { time: '2018-12-29', value: 23.92 },
  { time: '2018-12-30', value: 22.68 },
  { time: '2018-12-31', value: 22.67 },
  { time: '2019-1-1', value: 23.67 },
  { time: '2019-1-2', value: 21.67 },
  { time: '2019-1-3', value: 25.67 },
  { time: '2019-1-4', value: 26.67 },
  { time: '2019-1-5', value: 20.67 },
  { time: '2019-1-6', value: 28.67 },
  { time: '2019-1-7', value: 18.67 },
  { time: '2019-1-8', value: 30.67 },
  { time: '2019-1-9', value: 31.67 },
  { time: '2019-1-10', value: 32.67 },
  { time: '2019-1-11', value: 42.67 },
  { time: '2019-1-12', value: 34.67 },
  { time: '2019-1-13', value: 31.67 },
  { time: '2019-1-14', value: 36.67 },
  { time: '2019-1-15', value: 28.67 },
  { time: '2019-1-16', value: 38.67 },
];

interface GetTimeSeriesProps {
  asset: Entity;
  resolution: Resolution;
  dateFrom: string;
  dateTo: string;
}

export const useChartV2 = () => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const openSearch = () => setIsSearchOpen(true);
  const closeSearch = () => setIsSearchOpen(false);
  const [activeAssets, setActiveAssets] = useState<Entity[]>([]);

  const getTimeSeries = ({
    asset,
    dateFrom,
    dateTo,
    resolution,
  }: GetTimeSeriesProps) => {
    getPrice({
      ticker: asset.ticker.toUpperCase(),
      entityTag: asset.tag,
      resolution,
      dateFrom,
      dateTo,
    });
  };

  useEffect(() => {
    if (activeAssets.length) {
      // TODO add domain values for dates and resolution from dropdown
      getTimeSeries({
        asset: activeAssets[0],
        dateFrom: '2000-10-01T00:00:00Z',
        dateTo: '2023-10-04T00:00:00Z',
        resolution: '1h',
      });
    }
  }, [activeAssets]);

  return {
    initialData,
    getTimeSeries,
    isSearchOpen,
    setIsSearchOpen,
    openSearch,
    closeSearch,
    activeAssets,
    setActiveAssets,
  };
};
